import React, { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Helmet } from "react-helmet";
import { addContact } from "../../../services/Users";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import AvailableOn from "../../AvailableOn/AvailableOn";
import "./Contact.css";

function Contact() {
  const recaptchaRef = useRef(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [message, setMessage] = useState("");
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [googleSocialLink, setGoogleSocialLink] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/admin/getConfig`
      );
      setGoogleSocialLink(response.data.data.social_google_link);
      return response.data;
    } catch (error) {
      // config fetch failure is non-critical
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name) { toast.info("Name is required!"); return; }
    if (!email) { toast.info("Email is required!"); return; }
    if (!phone) { toast.info("Phone No. is required!"); return; }
    if (!message) { toast.info("Message is required!"); return; }
    if (!recaptchaValue) { toast.info("Please complete the reCAPTCHA!"); return; }

    const formData = { name, email, phone, location, message };

    try {
      const { data } = await addContact(formData);
      toast(data.msg);
      setShowPopup(true);
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong");
    }

    setName("");
    setPhone("");
    setEmail("");
    setLocation("");
    setMessage("");
    setRecaptchaValue(null);
    recaptchaRef.current?.reset();
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kuku Namkeen | Contact Us</title>
        <meta
          name="description"
          content="Contact KUKU Namkeen — reach us by phone, WhatsApp or email for orders and enquiries."
        />
        <link rel="canonical" href="https://kukunamkeen.in/contact" />
      </Helmet>

      {/* ── Page Header ── */}
      <section className="contact-header-title">
        <div className="max-w-6xl mx-auto px-4">
          <h1>CONTACT US</h1>
        </div>
      </section>
      <img
        src="/Image/border-bottom-title.png"
        className="w-full header-title-image"
        alt=""
      />

      {/* ── Contact Info Cards ── */}
      <section className="contact-page">
        <div className="contact-info-grid px-4">
          {/* Address */}
          <div className="contact-info-container">
            <div className="contact-info-icon-wrapper">
              <i className="bi bi-geo"></i>
            </div>
            <div className="contact-info-content">
              <h5>ADDRESS</h5>
              <p>
                Shed no. A-4B, Hirji Mistry Rd, Nr.<br />
                Nana udhyog vasahat, Jamnagar,<br />
                Gujarat-361006
              </p>
            </div>
          </div>

          {/* Phone */}
          <div className="contact-info-container">
            <div className="contact-info-icon-wrapper">
              <i className="bi bi-phone"></i>
            </div>
            <div className="contact-info-content">
              <h5>CONTACT</h5>
              <p>
                <a href="tel:+918780266042">+91 87802 66042</a>
              </p>
            </div>
          </div>

          {/* WhatsApp */}
          <div className="contact-info-container">
            <div className="contact-info-icon-wrapper">
              <i className="bi bi-whatsapp"></i>
            </div>
            <div className="contact-info-content">
              <h5>Whatsapp</h5>
              <p>
                <a
                  href="https://api.whatsapp.com/send/?phone=919427265661&text=we%20want%20to%20inquiry%20for%20Kuku%20Products"
                  target="_blank"
                  rel="noreferrer"
                >
                  +91 94272 65661
                </a>
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="contact-info-container">
            <div className="contact-info-icon-wrapper">
              <i className="bi bi-envelope"></i>
            </div>
            <div className="contact-info-content">
              <h5>EMAIL</h5>
              <p>
                <a href="mailto:kukunamkeen65@gmail.com">
                  kukunamkeen65@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Contact Form + Map ── */}
      <section className="contact-form-section">
        <div className="contact-form-bg-bar"></div>

        <div className="contact-form-inner-wrap">
          {/* Form */}
          <div className="form-innersection">
            <h1>Let's Connect</h1>
            <form onSubmit={handleSubmit}>
              <div className="form-row-2">
                {/* Name */}
                <div className="form-floating-group">
                  <input
                    type="text"
                    id="contact-name"
                    placeholder=" "
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <label htmlFor="contact-name">Name</label>
                </div>

                {/* Mobile */}
                <div className="form-floating-group">
                  <input
                    type="tel"
                    id="contact-phone"
                    placeholder=" "
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  <label htmlFor="contact-phone">Your Mobile</label>
                </div>

                {/* Email */}
                <div className="form-floating-group">
                  <input
                    type="email"
                    id="contact-email"
                    placeholder=" "
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <label htmlFor="contact-email">email@yourmail.com</label>
                </div>

                {/* Location */}
                <div className="form-floating-group">
                  <input
                    type="text"
                    id="contact-location"
                    placeholder=" "
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                  />
                  <label htmlFor="contact-location">Location</label>
                </div>
              </div>

              {/* Message */}
              <div className="form-floating-group">
                <textarea
                  id="contact-message"
                  placeholder=" "
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <label htmlFor="contact-message">Message</label>
              </div>

              {/* reCAPTCHA */}
              <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "center" }}>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                  onChange={(value) => setRecaptchaValue(value)}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <button type="submit" id="contact-submit" className="btn-kuku-two">
                  Send Inquiry
                </button>
              </div>
            </form>
          </div>

          {/* Map */}
          <div className="contact-map-container">
            <iframe
              title="Kuku Namkeen Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d921.7915768308333!2d70.05209943136632!3d22.460383875380682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39576bcd55c3302f%3A0xb00f29fbbe9a6727!2sKuku%20namkeen!5e0!3m2!1sen!2sin!4v1772824315101!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* ── Success Popup ── */}
      {showPopup && (
        <div
          className="contact-popup-overlay"
          onClick={() => setShowPopup(false)}
        >
          <div
            className="contact-popup-box"
            onClick={(e) => e.stopPropagation()}
          >
            <p>We'll be in touch shortly!</p>
            <button
              id="contact-popup-ok"
              className="btn-kuku-two"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <AvailableOn />
    </>
  );
}

export default Contact;
